import React, { useMemo } from 'react';
import CommentIcon from '@mui/icons-material/Comment';
import { Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMessage } from 'modules/intl';
import { SmartDiaryEntry } from '../type';
import { SmartDiaryTooltip } from './SmartDiaryTooltip';

type SmartDiaryCommentProps = { smartEntry: SmartDiaryEntry };

const useStyles = makeStyles((theme) => ({
  comment: {
    alignSelf: 'center',
    margin: theme.spacing(0, 0, 0, 1),
    color: theme.palette.primary.main
  },
  spaceholder: {
    width: theme.spacing(4),
    height: theme.spacing(3)
  }
}));

export const SmartDiaryComment: React.FC<SmartDiaryCommentProps> = ({
  smartEntry
}: SmartDiaryCommentProps) => {
  const classes = useStyles();

  const comments = useMemo(() => {
    if (smartEntry.comment?.value?.length) {
      return smartEntry.comment.value;
    }
    return '';
  }, [smartEntry.comment?.value]);
  const title = useMemo(
    () => <TooltipTitle id={smartEntry.id} comment={comments} />,
    [comments, smartEntry.id]
  );

  if (!smartEntry.comment?.value?.length) {
    return <div className={classes.spaceholder}></div>;
  }

  return (
    <Tooltip title={title} arrow>
      <CommentIcon
        data-testid={`smart-entry-item_comment_${smartEntry.id}`}
        className={classes.comment}
      />
    </Tooltip>
  );
};

type TooltipTitleProp = {
  id: string;
  comment?: string;
};

const TooltipTitle: React.FC<TooltipTitleProp> = ({
  id,
  comment
}: TooltipTitleProp) => {
  const message = useMessage('timesheetLabels.comment');

  return (
    <div>
      {comment?.length && (
        <div>
          <SmartDiaryTooltip
            id={`tooltip_key_comment_${id}`}
            name={message}
            value={comment}
          ></SmartDiaryTooltip>
        </div>
      )}
    </div>
  );
};
